import {
  FullscreenOverlayBackdrop,
  FullscreenOverlayBody,
  FullscreenOverlayContent,
  FullscreenOverlayHeader,
  FullscreenOverlayPortal,
  FullscreenOverlayRoot,
} from '../../../ui/FullscreenOverlay';
import { ListingHeaderActions } from '../ListingHeaderActions';
import * as styles from './tourLightbox.styles';

type TourLightboxProps = {
  tourUrl: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const TourLightbox = ({ tourUrl, open, onOpenChange }: TourLightboxProps) => (
  <FullscreenOverlayRoot open={open} onOpenChange={onOpenChange}>
    <FullscreenOverlayPortal>
      <FullscreenOverlayBackdrop>
        <FullscreenOverlayContent
          variant="media"
          className={styles.tourLightboxContent}
          ariaLabelledBy="tour-lightbox-title"
        >
          <div className={styles.tourLightboxHeader}>
            <FullscreenOverlayHeader layout="sticky" variant="media" actions={<ListingHeaderActions />} />
          </div>

          <FullscreenOverlayBody variant="media" padding="edge-to-edge">
            <div className={styles.tourLightboxContainer}>
              <iframe
                src={tourUrl}
                title="3D Tour"
                id="tour-lightbox-title"
                aria-label="Interactive 3D tour of the property"
                className={styles.tourLightboxIframe}
                sandbox="allow-scripts allow-same-origin"
                allowFullScreen
              />
            </div>
          </FullscreenOverlayBody>
        </FullscreenOverlayContent>
      </FullscreenOverlayBackdrop>
    </FullscreenOverlayPortal>
  </FullscreenOverlayRoot>
);
